import { motion } from "framer-motion";
import { Droplets, Layers, Waves, Gauge, FlaskConical, MapPin } from "lucide-react";

const SERVICES = [
  {
    icon: Droplets,
    title: "Foraje puțuri apă potabilă",
    desc: "Forăm puțuri de apă de la 10 la 150 de metri, în curtea casei tale, în tot București-Ilfov.",
    span: true,
  },
  {
    icon: Layers,
    title: "Tubulatură PVC albastră cu filet",
    desc: "Țevi certificate pentru apă potabilă, înșurubate etanș segment cu segment: Ø125, Ø140, Ø160.",
  },
  {
    icon: Waves,
    title: "Denisipări și curățare",
    desc: "Scoatem nisipul și limpezim puțurile existente, ca să revii la debit și apă curată.",
  },
  {
    icon: Gauge,
    title: "Montaj pompe și hidrofoare",
    desc: "Instalăm pompe submersibile și hidrofoare, dimensionate pentru adâncimea puțului tău.",
  },
  {
    icon: FlaskConical,
    title: "Pompaj și test de debit",
    desc: "Verificăm debitul și limpezirea apei înainte de a preda puțul, gata de folosire.",
  },
  {
    icon: MapPin,
    title: "București și tot Ilfovul",
    desc: "Ducem utilajul în toate sectoarele capitalei și în localitățile din județul Ilfov.",
  },
];

const fadeUp = {
  hidden: { opacity: 0, y: 28 },
  show: (i) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.6, delay: i * 0.07, ease: [0.22, 1, 0.36, 1] },
  }),
};

export default function ServicesSection() {
  return (
    <section id="servicii" className="scroll-mt-16 bg-hydro-navy py-24 md:py-32">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <motion.div
          initial={{ opacity: 0, y: 28 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.15 }}
          transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
        >
          <p className="font-mono text-[11px] uppercase tracking-[0.32em] text-hydro-cyan sm:text-xs">
            Servicii
          </p>
          <h2 className="mt-4 max-w-2xl font-display text-4xl font-extrabold leading-[1.02] tracking-tight text-white sm:text-5xl md:text-6xl">
            De la foraj la apa din robinet.
          </h2>
        </motion.div>

        <div className="mt-12 grid gap-4 md:grid-cols-2 lg:grid-cols-3">
          {SERVICES.map((s, i) => (
            <motion.div
              key={s.title}
              variants={fadeUp}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true, amount: 0.15 }}
              custom={i}
              className={`group rounded-3xl border border-white/10 bg-white/[0.04] p-7 transition-all hover:border-hydro-cyan/40 hover:bg-white/[0.07] ${
                s.span ? "lg:col-span-2" : ""
              }`}
            >
              <div className="flex items-start justify-between">
                <div className="grid h-11 w-11 place-items-center rounded-xl bg-hydro-cyan/10 text-hydro-cyan transition-colors group-hover:bg-hydro-cyan group-hover:text-hydro-navy">
                  <s.icon size={20} />
                </div>
                <span className="font-mono text-xs text-white/25">
                  {String(i + 1).padStart(2, "0")}
                </span>
              </div>
              <h3 className="mt-6 font-display text-xl font-bold text-white">{s.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-white/60">{s.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
